module.exports = __webpack_public_path__ + "img/refusol.6f649441.png";